import '../../templates/_layouts/types/search-page.js'
import '../../templates/_layouts/types/all-courses.js'
import '../../templates/_layouts/types/course-v2.js'
import '../../templates/_layouts/types/my-saved-courses.js'
import '../../templates/_layouts/types/careers-quiz.js'
import '../../templates/_layouts/types/microsite.js'
